import constants from '../constants'

export const cleanOrigin = (path = '') => {
  const origin = constants.urls.SITE || window.location.origin
  const clean = path.replace(origin, '')
  if (clean.startsWith('/')) {
    return clean
  }
  return `/${clean}`
}

export const checkEmpty = (el) => {
  return el !== undefined
}

export const isInternal = (to) => {
  const linkSplit = to.split('/')
  if (to.indexOf(constants.urls.SITE) === 0) return true
  if (to.indexOf('://') === -1) return true
  if (linkSplit[linkSplit.length - 1].indexOf('.') === -1) return false
  return window.location.hostname === to.hostname
}

export const getSlug = (pathname = '') => {
  const pathArray = pathname.split('/').filter((p) => p !== '')
  return pathArray.slice(pathArray.length - 1)
}
